// ========= S3 CONFIG =========
const BUCKET_NAME = "zory-temporary-uploads"
const REGION = "me-central-1"
const GALLERY_IMAGES_ENV = process.env.REACT_APP_GALLERY_IMAGES_ENV

export const S3_CONFIG = {
  bucketName: BUCKET_NAME,
  region: REGION,
  bucketUrl: `https://${BUCKET_NAME}.s3.${REGION}.amazonaws.com/gallery_images`,
}

// console.log(GALLERY_IMAGES_ENV, "GALLERY_IMAGES_ENV 0000")
// console.log("Check ENV:", process.env.REACT_APP_GALLERY_IMAGES_ENV)

// ========= HELPERS =========
const pad = (n) => String(n).padStart(2, "0")

export const generateTimestampId = () => {
  const d = new Date()
  return (
    `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}` +
    `${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}` +
    String(d.getMilliseconds()).padStart(3, "0") +
    String(Math.floor(Math.random() * 100)).padStart(2, "0")
  )
}

export const getFileExtension = (filename, fallback = "jpg") => {
  const lastDot = (filename || "").lastIndexOf(".")
  return lastDot === -1 ? fallback : filename.slice(lastDot + 1).toLowerCase()
}

export const generateUniqueFileName = (file) =>
  `${generateTimestampId()}.${getFileExtension(file?.name, "jpg")}`

const cleanSegment = (s) =>
  String(s || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-_]/g, "")

export function extractFiles(value) {
  if (!value) return []
  const one = (v) =>
    v?.originFileObj instanceof File
      ? v.originFileObj
      : v instanceof File
      ? v
      : null
  return Array.isArray(value)
    ? value.map(one).filter(Boolean)
    : one(value)
    ? [one(value)]
    : []
}

// ========= KEY BUILDER =========
/**
 * gallery_images_stage/{roomType}/{decoreStyle}/{theme}/{filename}
 */
export const buildGalleryKey = ({ roomType, decoreStyle, theme, filename }) => {
  //   const formatLabel = (str) => {
  //     if (!str) return ""
  //     return str
  //       .split(/[_\s]+/)
  //       .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  //       .join(" ")
  //   }

  function formatLabel(value) {
    if (!value) return ""

    // 1. Decode URL encodings (like %20 → space)
    let decoded = decodeURIComponent(value)

    // 2. Replace spaces with underscores
    decoded = decoded.replace(/\s+/g, "_")

    // 3. Split by underscore and capitalize each word
    return decoded
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join("_")
  }

  const rt = formatLabel(cleanSegment(roomType))
  const ds = formatLabel(cleanSegment(decoreStyle))
  const th = formatLabel(cleanSegment(theme))

  if (!rt || !ds || !th)
    throw new Error("roomType, decoreStyle, theme required")

  // Nested folders
  return `${GALLERY_IMAGES_ENV}/${rt}/${ds}/${th}/${filename}`
}

// ========= VALIDATION =========
export const validateImageFile = (file, maxSizeMB = 1) => {
  if (!file) throw new Error("No file provided")
  if (!file.type?.startsWith("image/"))
    throw new Error("Only image files are allowed")
  if (file.size > maxSizeMB * 1024 * 1024)
    throw new Error(`File size must be less than ${maxSizeMB}MB`)
  return true
}

// ========= DIRECT UPLOAD =========
export async function uploadFileToS3(file, key) {
  const uploadUrl = `${S3_CONFIG.bucketUrl}/${key}`

  const resp = await fetch(uploadUrl, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type || "image/jpeg" },
  })

  if (!resp.ok) {
    const txt = await resp.text().catch(() => "")
    throw new Error(`Upload failed ${resp.status}: ${txt || resp.statusText}`)
  }

  return true
}

// ========= PUBLIC URL =========
export const getPublicUrl = (key) => `${S3_CONFIG.bucketUrl}/${key}`
